import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	users: data.data,
	pagesTotal: data.last_page,
});

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
